import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiHome, FiArrowLeft, FiLogIn, FiShield } from 'react-icons/fi';
import Button from '../../components/common/Button';
import { useAuth } from '../../contexts/AuthContext';

const Unauthorized = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    navigate('/');
  };

  const handleLogin = () => {
    navigate('/login');
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="error-page">
      <div className="error-container">
        <div className="error-illustration">
          <div className="error-code">401</div>
          <FiShield className="error-icon" size={64} />
        </div>
        
        <div className="error-content">
          <h1 className="error-title">Access Denied</h1>
          <p className="error-description">
            {user ? (
              "You don't have permission to access this page. Your current role may not have the required privileges."
            ) : (
              "You need to be logged in to access this page. Please sign in with your account."
            )}
          </p>
          
          <div className="error-suggestions">
            <h3>What you can do:</h3>
            <ul>
              {user ? (
                <>
                  <li>Contact your administrator to request access</li>
                  <li>Check if you're using the correct account</li>
                  <li>Try logging out and back in</li>
                  <li>Go back to the previous page</li>
                </>
              ) : (
                <>
                  <li>Sign in with your account</li>
                  <li>Create a new account if you don't have one</li>
                  <li>Reset your password if you forgot it</li>
                  <li>Contact support for help</li>
                </>
              )}
            </ul>
          </div>
          
          <div className="error-actions">
            <Button 
              variant="outline" 
              onClick={handleGoBack}
              className="action-button"
            >
              <FiArrowLeft size={16} />
              Go Back
            </Button>
            
            <Button 
              variant="primary" 
              onClick={handleGoHome}
              className="action-button"
            >
              <FiHome size={16} />
              Go Home
            </Button>
            
            {user ? (
              <Button 
                variant="secondary" 
                onClick={handleLogout}
                className="action-button"
              >
                <FiLogIn size={16} />
                Switch Account
              </Button>
            ) : (
              <Button 
                variant="secondary" 
                onClick={handleLogin}
                className="action-button"
              >
                <FiLogIn size={16} />
                Sign In
              </Button>
            )}
          </div>
          
          {user && (
            <div className="user-info">
              <p>
                <strong>Current User:</strong> {user.name} ({user.email})
              </p>
              <p>
                <strong>Role:</strong> {user.role}
              </p>
            </div>
          )}
        </div>
        
        <div className="error-footer">
          <p>
            Need help? <Link to="/contact">Contact Support</Link> or{' '}
            <Link to="/help">View Help Center</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;